export default __webpack_public_path__ + "static/educacao-infantil-active-5aab5c193da9f380958e3768c5d4427d.svg";